import { Mail } from 'lucide-react';
import { BAND_EMAIL } from '../constants/contact';

interface ContactCTAProps {
    title?: string;
    description?: string;
    className?: string;
}

export function ContactCTA({
    title = 'Get in Touch',
    description = 'Have questions or want to book us for an event?',
    className = '',
}: ContactCTAProps) {
    return (
        <div
            className={`max-w-6xl mx-auto px-4 mt-16 p-8 bg-card border border-border rounded-lg text-center ${className}`}
        >
            <h3 className="text-2xl font-bold text-primary mb-4">{title}</h3>
            <p className="text-foreground mb-4 opacity-75">{description}</p>
            <a
                href={`mailto:${BAND_EMAIL}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-semibold uppercase tracking-wider rounded hover:opacity-90 transition-opacity"
            >
                <Mail className="w-5 h-5" />
                Contact Us
            </a>
        </div>
    );
}
